// extracted by mini-css-extract-plugin
module.exports = {"limitHeight":"Account_limitHeight__3HDYl","widthLimit":"Account_widthLimit__1oLMY"};